import { Button } from "@blueprintjs/core";
import React, { useState } from "react";
import { MonacoDiffEditor } from "react-monaco-editor";

import { Box, useDarkMode } from ".";
import ThemedDialog from "./themed-dialog";
import { deepSortObject } from "ui-lib";

const JsonDiffModalButton: React.FC<{
  currentValue: Object;
  previousValue: Object;
  minimal?: boolean;
  childern?: React.ReactNode | null;
}> = ({ currentValue, previousValue, minimal = true, children = null }) => {
  const [darkMode] = useDarkMode();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ThemedDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        style={{ paddingBottom: 0, width: "90vw", height: "80vh" }}
      >
        <Box width="1" height="1">
          <MonacoDiffEditor
            language="json"
            theme={darkMode ? "vs-dark" : "vs-light"}
            options={{ automaticLayout: true, readOnly: true }}
            original={JSON.stringify(deepSortObject(previousValue), null, 2)}
            value={JSON.stringify(deepSortObject(currentValue), null, 2)}
          />
        </Box>
      </ThemedDialog>

      <Button
        style={{ width: "29px" }}
        small
        minimal={minimal}
        icon="comparison"
        onClick={() => setIsOpen((p) => !p)}
      >
        {children}
      </Button>
    </>
  );
};

export default JsonDiffModalButton;
